import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timepipe',
})
export class timepipe implements PipeTransform {
  transform(value: any) {
    return moment(value, 'h:mm').format('h:mm A');
  }
}
